import React, { FC } from "react";

import { Button, Col, ListGroup, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";

import classNames from "classnames";
import { Link, To } from "react-router-dom";

import styles from "./TaskNotification.module.scss";

export interface TaskNotificationProps {
  title: JSX.Element;
  messageList: string[];
  to: To;
  buttoneTxt: string;
}
export const TaskNotification: FC<TaskNotificationProps> = ({ title, messageList, to, buttoneTxt }) => {
  return (
    <div className={classNames(styles["notification"])}>
      <Card className={classNames(styles["card"], "notification")}>
        <Card.Body>
          <Row>
            <Col>
              <Card.Text>{title}</Card.Text>
              <ListGroup className={classNames(styles["notification-list"])} variant="flush">
                {messageList.length > 0 &&
                  messageList.map((value) => <ListGroup.Item key={value}>{value}</ListGroup.Item>)}
              </ListGroup>
            </Col>
            <Col>
              <Button className={classNames(styles["task-button"])}>
                <Link to={to}>{buttoneTxt}</Link>
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};
